import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entity-value-input" }
const _hoisted_2 = {
  key: 0,
  role: "alert"
}
const _hoisted_3 = { key: 1 }

import { computed, type HTMLAttributes } from "vue";
import { NSelect } from "naive-ui";
import { studioSelectTheme } from "../studioSelectTheme";
import TypedValueInput from "../TypedValueInput.vue";
import "../../studioSelect.css";
import { useEntityPresets } from "./useEntityPresets";
import { getEntityPresetValueOptions } from "./entityPresets";


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityPresetValueInput',
  props: {
    field: {},
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { availablePresets, ready, error, retry } = useEntityPresets();
const options = computed(() => getEntityPresetValueOptions(availablePresets.value, props.field));
const selected = computed(() => options.value.some(item => item.value === props.modelValue) ? props.modelValue : null);
const menuProps: HTMLAttributes & { "data-clip-editor": string } = { "data-clip-editor": "", class: "studio-select-menu" };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_unref(NSelect), {
      "theme-overrides": _unref(studioSelectTheme),
      value: selected.value,
      options: options.value,
      disabled: !_unref(ready),
      filterable: "",
      "menu-props": menuProps,
      "aria-label": __props.label + '实体预设',
      placeholder: "搜索实体预设",
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }, null, 8, ["theme-overrides", "value", "options", "disabled", "aria-label"]),
    _createVNode(TypedValueInput, {
      "model-value": __props.modelValue,
      "value-type": __props.field === 'guid' ? 'Guid' : 'String',
      "aria-label": __props.label,
      placeholder: "也可手动填写",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
    }, null, 8, ["model-value", "value-type", "aria-label"]),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(retry)().catch(() => undefined)))
          }, "重试")
        ]))
      : (_unref(ready) && !options.value.length)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, "暂无可用值，请在实体预设中填写" + _toDisplayString(__props.field === 'guid' ? 'guid' : '实体查询') + "。", 1))
        : _createCommentVNode("", true)
  ]))
}
}

})